import { getPriorityIcon, getPriorityLabel } from "@utils/priority"

import { Badge } from "@atoms"
import { getPriorityIconClassName } from "@atoms/PriorityIcon/PriorityIcon.utils"

import { PriorityBadgeProps } from "./PriorityBadge.types"

export default function PriorityBadge(props: PriorityBadgeProps) {
    const { priority, size = "md" } = props

    // "Urgent priority", "High priority", … and "No priority" when unset.
    const tooltip = priority == null ? "No priority" : `${getPriorityLabel(priority)} priority`

    return (
        <Badge
            size={size}
            variant="icon"
            icon={getPriorityIcon(priority)}
            iconContainer="square"
            iconClassName={getPriorityIconClassName(priority)}
            tooltip={tooltip}
        />
    )
}
